// Tahsilatlar — önce onay kuyruğu (dekont önizlemeli), altında tahsilat geçmişi
import { api } from '../api';
import { state, isAdmin, navigate } from '../app';
import { esc, $, $$, setHTML, formatCurrency, formatDate, statusBadge, statusLabel, icons, today } from '../helpers';
import { toast, openModal, closeModal, confirmDialog, setBreadcrumb, skeletonTable } from '../ui';

type PFilter = 'all' | 'pending' | 'confirmed' | 'rejected';
let pFilter: PFilter = 'all';
let pQuery = '';

export async function renderPayments() {
  const content = $('#content')!;
  setBreadcrumb([{ label: 'Panel', href: '/dashboard' }, { label: 'Tahsilatlar' }]);
  setHTML(content, skeletonTable(7, 5));
  try {
    const data = await api.get('/payments');
    const all: any[] = data.payments || [];
    const s = data.summary || {};
    const pending = all.filter(p => p.status === 'pending');

    // Müşteri görünümü: ödeme bekleyen faturalar üstte
    let unpaidBanner = '';
    if (!isAdmin()) {
      try {
        const inv = await api.get('/invoices');
        const unpaid = (inv.invoices || []).filter((i: any) => i.status === 'unpaid' || i.status === 'overdue');
        if (unpaid.length) {
          unpaidBanner = `<div class="card mb-2"><div class="card-header"><h3>Ödeme bekleyen faturalar</h3><span class="chip chip-warn">${unpaid.length}</span></div>
            <div class="card-body no-pad"><div class="client-list" style="padding:8px">${unpaid.map((u: any) => `<a href="/invoices/${u.id}" class="client-row">
              <div class="client-main"><div class="client-title font-mono">${esc(u.invoice_number)}</div><div class="client-sub">${esc(u.project_title || u.description || '')}</div>
              <div class="client-meta">${u.due_date ? 'Vade ' + formatDate(u.due_date) : ''}${u.overdue_days > 0 ? ' · <span class="text-danger">' + u.overdue_days + ' gün gecikti</span>' : ''}</div></div>
              <div class="client-fin"><span class="amt ${u.overdue_days > 0 ? 'amt-danger' : ''}">${formatCurrency(u.remaining ?? u.total, u.currency)}</span><span class="amt-sub">ödemek için dokunun</span></div>
            </a>`).join('')}</div></div></div>`;
        }
      } catch { /* yoksay */ }
    }

    setHTML(content, `<div>
      <div class="page-header"><div><h1>Tahsilatlar</h1><p class="page-sub">${isAdmin() ? formatCurrency(s.collected_year || 0) + ' bu yıl tahsil edildi' : 'Ödemeleriniz ve durumları'}</p></div>
        ${isAdmin() ? '<div class="page-header-actions"><button class="btn btn-secondary" id="pay-csv"><i data-lucide="download"></i> CSV</button><button class="btn btn-primary" id="add-payment-btn"><i data-lucide="plus"></i> Tahsilat gir</button></div>' : ''}</div>

      ${isAdmin() && pending.length ? `<div class="card queue mb-2"><div class="card-header"><h3><i data-lucide="inbox" style="width:18px;height:18px;vertical-align:-3px"></i> Onay bekleyen havale bildirimleri</h3><span class="chip chip-warn">${pending.length} · ${formatCurrency(s.pending_amount || 0)}</span></div>
        <div class="card-body no-pad"><div class="queue-list">${pending.map(p => `<div class="queue-item">
          <div class="queue-main">
            <div class="queue-top"><a href="/invoices/${p.invoice_id}" class="font-mono table-link">${esc(p.invoice_number)}</a><span class="queue-amt">${formatCurrency(p.amount, p.currency)}</span></div>
            <div class="queue-sub">${esc(p.client_company || p.client_name)}</div>
            <div class="queue-meta">${formatDate(p.payment_date || p.created_at)}${p.bank_name ? ' · ' + esc(p.bank_name) : ''}${p.sender_name ? ' · ' + esc(p.sender_name) : ''}${p.bank_reference ? ' · <span class="font-mono">' + esc(p.bank_reference) + '</span>' : ''}</div>
            ${Math.abs((p.amount || 0) - (p.invoice_total || 0)) > 0.01 ? `<div class="queue-warn"><i data-lucide="alert-triangle"></i> Fatura tutarı ${formatCurrency(p.invoice_total, p.invoice_currency)} — tutarlar farklı</div>` : ''}
          </div>
          <div class="queue-actions">
            ${p.receipt_doc_id ? `<button class="btn btn-secondary btn-sm" data-receipt="${p.receipt_doc_id}"><i data-lucide="file-text"></i> Dekont</button>` : '<span class="chip chip-muted">Dekont yok</span>'}
            <button class="btn btn-primary btn-sm" data-ok="${p.id}"><i data-lucide="check"></i> Onayla</button>
            <button class="btn btn-ghost btn-sm" data-no="${p.id}" title="Reddet"><i data-lucide="x"></i></button>
          </div></div>`).join('')}</div></div></div>` : ''}
      ${unpaidBanner}

      <div class="list-tools"><div class="search-input-wrapper"><i data-lucide="search"></i><input type="search" id="pay-search" placeholder="Fatura no, müşteri, banka, dekont no…" autocomplete="off"></div></div>
      <div class="filters-bar" id="pay-filters">
        ${([['all', 'Tümü', all.length], ['pending', 'Beklemede', pending.length], ['confirmed', 'Onaylandı', all.filter(p => p.status === 'confirmed').length], ['rejected', 'Reddedildi', all.filter(p => p.status === 'rejected').length]] as [PFilter, string, number][])
          .map(([f, l, n]) => `<button class="filter-chip${pFilter === f ? ' active' : ''}" data-f="${f}">${l} <span class="chip-count">${n}</span></button>`).join('')}
      </div>
      <div id="pay-list"></div>
    </div>`);
    icons();

    const draw = () => {
      const q = pQuery.toLowerCase();
      const rows = all.filter(p => {
        if (pFilter !== 'all' && p.status !== pFilter) return false;
        if (!q) return true;
        return [p.invoice_number, p.client_name, p.client_company, p.bank_name, p.sender_name, p.bank_reference].filter(Boolean).join(' ').toLowerCase().includes(q);
      });
      const el = $('#pay-list')!;
      if (!rows.length) { setHTML(el, '<div class="empty-state"><i data-lucide="wallet"></i><p>Kayıt yok</p></div>'); icons(); return; }
      setHTML(el, `<div class="client-list">${rows.map(p => `<div class="client-row" style="cursor:default">
        <div class="client-main">
          <div class="client-title"><a href="/invoices/${p.invoice_id}" class="table-link font-mono">${esc(p.invoice_number)}</a></div>
          ${isAdmin() ? `<div class="client-sub">${esc(p.client_company || p.client_name)}</div>` : ''}
          <div class="client-meta">${formatDate(p.payment_date || p.created_at)}${p.bank_name ? ' · ' + esc(p.bank_name) : ''}${p.bank_reference ? ' · <span class="font-mono">' + esc(p.bank_reference) + '</span>' : ''}</div>
          <div class="client-chips">${statusBadge(p.status)}${p.receipt_doc_id ? '<span class="chip chip-muted">Dekont var</span>' : ''}</div>
        </div>
        <div class="client-fin"><span class="amt">${formatCurrency(p.amount, p.currency)}</span>
          ${isAdmin() ? `<span class="amt-sub"><button class="btn btn-ghost btn-sm" data-edit="${p.id}" title="Düzenle"><i data-lucide="pencil"></i></button><button class="btn btn-ghost btn-sm" data-del="${p.id}" title="Sil"><i data-lucide="trash-2"></i></button></span>` : ''}
        </div></div>`).join('')}</div>`);
      icons();
      $$('[data-edit]').forEach(b => b.addEventListener('click', () => editPayment(all.find(x => x.id === parseInt(b.getAttribute('data-edit')!)))));
      $$('[data-del]').forEach(b => b.addEventListener('click', async () => {
        if (await confirmDialog('Tahsilatı sil', 'Bu tahsilat kaydı silinsin mi? Fatura durumu otomatik güncellenmez.', 'Sil', 'danger')) {
          try { await api.del('/payments/' + b.getAttribute('data-del')); toast('Silindi', 'success'); renderPayments(); } catch (err: any) { toast(err.message, 'error'); }
        }
      }));
    };
    draw();

    $$('#pay-filters .filter-chip').forEach(b => b.addEventListener('click', () => {
      pFilter = b.getAttribute('data-f') as PFilter;
      $$('#pay-filters .filter-chip').forEach(x => x.classList.toggle('active', x === b));
      draw();
    }));
    let t: any;
    (document.getElementById('pay-search') as HTMLInputElement).addEventListener('input', (e) => {
      clearTimeout(t); t = setTimeout(() => { pQuery = (e.target as HTMLInputElement).value.trim(); draw(); }, 150);
    });
    $$('[data-ok]').forEach(b => b.addEventListener('click', async () => {
      try { await api.put('/payments/' + b.getAttribute('data-ok'), { status: 'confirmed' }); toast('Tahsilat onaylandı, fatura güncellendi', 'success'); renderPayments(); }
      catch (err: any) { toast(err.message, 'error'); }
    }));
    $$('[data-no]').forEach(b => b.addEventListener('click', async () => {
      if (await confirmDialog('Bildirimi reddet', 'Havale bildirimi reddedilsin mi? Müşteri yeniden bildirim yapabilir.', 'Reddet', 'danger')) {
        try { await api.put('/payments/' + b.getAttribute('data-no'), { status: 'rejected' }); toast('Reddedildi', 'success'); renderPayments(); }
        catch (err: any) { toast(err.message, 'error'); }
      }
    }));
    $$('[data-receipt]').forEach(b => b.addEventListener('click', async () => {
      try {
        const res = await fetch('/api/documents/' + b.getAttribute('data-receipt') + '/file', { headers: { Authorization: 'Bearer ' + state.token } });
        if (!res.ok) throw new Error('Dekont açılamadı');
        const url = URL.createObjectURL(await res.blob());
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (err: any) { toast(err.message, 'error'); }
    }));
    document.getElementById('add-payment-btn')?.addEventListener('click', () => openPaymentForm());
    document.getElementById('pay-csv')?.addEventListener('click', () => {
      const q = (v: any) => '"' + String(v ?? '').replace(/"/g, '""') + '"';
      const n = (v: any) => String(Number(v || 0).toFixed(2)).replace('.', ',');
      let csv = '﻿Tarih;Fatura No;Müşteri;Banka;Gönderen;Dekont No;Tutar;Para;Durum\n';
      all.forEach(p => { csv += [p.payment_date || p.created_at, p.invoice_number, p.client_company || p.client_name, p.bank_name, p.sender_name, p.bank_reference, n(p.amount), p.currency, statusLabel(p.status)].map(q).join(';') + '\n'; });
      const u = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
      const a = document.createElement('a'); a.href = u; a.download = 'tahsilatlar.csv'; a.click(); URL.revokeObjectURL(u);
    });
  } catch (err: any) { toast(err.message, 'error'); }
}

async function openPaymentForm() {
  let opts = '';
  try {
    const d = await api.get('/invoices');
    opts = (d.invoices || []).filter((i: any) => i.status !== 'paid' && i.status !== 'cancelled')
      .map((i: any) => `<option value="${i.id}" data-amount="${i.remaining ?? i.total}">${esc(i.invoice_number)} — ${esc(i.client_company || i.client_name)} — ${formatCurrency(i.remaining ?? i.total, i.currency)}</option>`).join('');
  } catch { /* yoksay */ }
  if (!opts) { toast('Ödenmemiş fatura yok', 'info'); return; }
  openModal('Tahsilat gir',
    `<form id="payment-form" class="auth-form" novalidate>
      <div class="form-group"><label>Fatura *</label><select name="invoice_id" id="pay-invoice" required>${opts}</select><span class="form-hint">Kalan tutar otomatik gelir; kısmi tahsilatta değiştirin</span></div>
      <div class="form-row"><div class="form-group"><label>Tarih *</label><input type="date" name="payment_date" value="${today()}" required></div>
      <div class="form-group"><label>Tutar *</label><input type="number" step="0.01" name="amount" id="pay-amount" required></div></div>
      <div class="form-row"><div class="form-group"><label>Banka</label><input type="text" name="bank_name" placeholder="Ziraat, Garanti…"></div>
      <div class="form-group"><label>Gönderen</label><input type="text" name="sender_name" placeholder="Dekonttaki ad"></div></div>
      <div class="form-row"><div class="form-group"><label>Dekont / referans no</label><input type="text" name="bank_reference"></div>
      <div class="form-group"><label>Durum</label><select name="status"><option value="confirmed">Onaylandı</option><option value="pending">Beklemede</option></select></div></div>
      <div class="form-group"><label>Not</label><textarea name="notes" rows="2"></textarea></div>
      <div class="modal-footer" style="padding:1rem 0 0"><button type="button" class="btn btn-secondary" id="pay-cancel">Vazgeç</button><button type="submit" class="btn btn-primary">Kaydet</button></div></form>`);
  const fill = () => {
    const sel = document.getElementById('pay-invoice') as unknown as HTMLSelectElement;
    const opt = sel.selectedOptions[0];
    if (opt) (document.getElementById('pay-amount') as HTMLInputElement).value = opt.getAttribute('data-amount') || '';
  };
  document.getElementById('pay-invoice')?.addEventListener('change', fill); fill();
  document.getElementById('pay-cancel')?.addEventListener('click', closeModal);
  document.getElementById('payment-form')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const body: any = Object.fromEntries(new FormData(e.target as HTMLFormElement));
    body.invoice_id = parseInt(body.invoice_id); body.amount = parseFloat(body.amount);
    try { await api.post('/payments', body); toast('Tahsilat kaydedildi', 'success'); closeModal(); renderPayments(); }
    catch (err: any) { toast(err.message, 'error'); }
  });
}

function editPayment(p: any) {
  if (!p) return;
  openModal('Tahsilatı düzenle — ' + p.invoice_number,
    `<form id="payment-edit-form" class="auth-form" novalidate>
      <div class="form-row"><div class="form-group"><label>Durum</label><select name="status">
        ${['pending', 'confirmed', 'rejected'].map(s => `<option value="${s}"${p.status === s ? ' selected' : ''}>${esc(statusLabel(s))}</option>`).join('')}</select></div>
      <div class="form-group"><label>Tutar</label><input type="number" step="0.01" name="amount" value="${p.amount}"></div></div>
      <div class="form-row"><div class="form-group"><label>Tarih</label><input type="date" name="payment_date" value="${(p.payment_date || '').split('T')[0]}"></div>
      <div class="form-group"><label>Banka</label><input type="text" name="bank_name" value="${esc(p.bank_name || '')}"></div></div>
      <div class="form-row"><div class="form-group"><label>Gönderen</label><input type="text" name="sender_name" value="${esc(p.sender_name || '')}"></div>
      <div class="form-group"><label>Dekont / referans</label><input type="text" name="bank_reference" value="${esc(p.bank_reference || '')}"></div></div>
      <div class="form-group"><label>Not</label><textarea name="notes" rows="2">${esc(p.notes || '')}</textarea></div>
      <div class="modal-footer" style="padding:1rem 0 0"><button type="button" class="btn btn-secondary" id="pe-cancel">Vazgeç</button><button type="submit" class="btn btn-primary">Güncelle</button></div></form>`);
  document.getElementById('pe-cancel')?.addEventListener('click', closeModal);
  document.getElementById('payment-edit-form')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const body: any = {};
    for (const [k, v] of new FormData(e.target as HTMLFormElement)) if (v !== '') body[k] = v;
    if (body.amount) body.amount = parseFloat(body.amount);
    try { await api.put('/payments/' + p.id, body); toast('Güncellendi', 'success'); closeModal(); navigate('/payments'); }
    catch (err: any) { toast(err.message, 'error'); }
  });
}
